// Action types for AI voice assistant
export const VAPI_CALL_START = "ai/vapi/CALL_START";
export const VAPI_CALL_END = "ai/vapi/CALL_END";
export const VAPI_CALL_ERROR = "ai/vapi/CALL_ERROR";
export const VAPI_CALL_STATUS_UPDATE = "ai/vapi/CALL_STATUS_UPDATE";
export const VAPI_TRANSCRIPT_UPDATE = "ai/vapi/TRANSCRIPT_UPDATE";
export const VAPI_SPEAKING_STATUS_UPDATE = "ai/vapi/SPEAKING_STATUS_UPDATE";
export const VAPI_SET_ELAPSED_TIME = "ai/vapi/SET_ELAPSED_TIME";
export const VAPI_SERVICE_READY = "ai/vapi/SERVICE_READY";
export const VAPI_SERVICE_ERROR = "ai/vapi/SERVICE_ERROR";
export const VAPI_SHOW_PERMISSION_CHECK = "ai/vapi/SHOW_PERMISSION_CHECK";
export const VAPI_HIDE_PERMISSION_CHECK = "ai/vapi/HIDE_PERMISSION_CHECK";
export const VAPI_CALL_CONNECTED = "ai/vapi/CALL_CONNECTED";
export const VAPI_SEND_BACKGROUND_MESSAGE = "ai/vapi/SEND_BACKGROUND_MESSAGE";
export const VAPI_TOGGLE_MUTE = "ai/vapi/TOGGLE_MUTE";
export const VAPI_SAY = "ai/vapi/SAY";
export const VAPI_SAY_AND_MUTE_AFTER = "ai/vapi/SAY_AND_MUTE_AFTER";
export const VAPI_MUTE_ASSISTANT = "ai/vapi/MUTE_ASSISTANT";
export const VAPI_UNMUTE_ASSISTANT = "ai/vapi/UNMUTE_ASSISTANT";
export const VAPI_TOGGLE_ASSISTANT_MUTE = "ai/vapi/TOGGLE_ASSISTANT_MUTE";
export const VAPI_ASSISTANT_JOINED_CALL = "ai/vapi/ASSISTANT_JOINED_CALL";
export const VAPI_SET_WAITING_FOR_ASSISTANT =
  "ai/vapi/SET_WAITING_FOR_ASSISTANT";
export const VAPI_SET_CALL_QUOTA = "ai/vapi/SET_CALL_QUOTA";
